import axios from "axios"

export const updatePushNotificationEnabledAnalytics = (notifications_enabled) =>
  axios.put("/api/v2/device/notifications_toggle", {
    notifications_enabled
  })

export const updatePushNotificationBlocks = (notification_blocks) =>
  axios.post("/api/v1/notification_blocks", {
    notification_blocks
  })

export const pushNotificationBlocks = () => axios.get("/api/v1/notification_blocks")
